import { RAILZ_SERVICES, RailzServiceNames } from 'vopay';

// The service list itself lives in the component library (vopay RAILZ_SERVICES), shared with the
// business-account response type. The widget only supports an exclude list, so "show one service"
// means excluding every other one.
export type RailzService = RailzServiceNames;

export function isRailzService(value: string | null): value is RailzService {
  return RAILZ_SERVICES.some((service) => service === value);
}

// Provider names are brand names, so they read the same in both locales and are never translated.
// This is the single source for them: the ERP marketplace cards take their names from here too, so
// a card and a message about it always say the same thing.
export const RAILZ_SERVICE_NAMES: { [service in RailzService]: string } = {
  freshbooks: 'FreshBooks',
  dynamicsBusinessCentral: 'Microsoft Dynamics 365',
  dynamics365Finance: 'MS Dynamics 365 Finance',
  oracleNetsuite: 'Oracle NetSuite',
  quickbooks: 'QuickBooks Online',
  quickbooksDesktop: 'QuickBooks Desktop',
  sageBusinessCloud: 'Sage Business Cloud',
  sageIntacct: 'Sage Intacct',
  zohoBooks: 'Zoho Books',
  wave: 'Wave',
  xero: 'Xero',
  myob: 'MYOB',
  plaid: 'Plaid',
  shopify: 'Shopify',
  square: 'Square',
};

/** Display name for a service Railz reports; an unrecognised one falls back to the raw value */
export function getRailzServiceName(service: string): string {
  return isRailzService(service) ? RAILZ_SERVICE_NAMES[service] : service;
}

export function railzServicesToExclude(selected: RailzService): RailzService[] {
  return RAILZ_SERVICES.filter((service) => service !== selected);
}

/** The `?service=` query param an ERP card navigates with, when it names a known service */
export function getRequestedRailzService(search: string): RailzService | undefined {
  const service = new URLSearchParams(search).get('service');

  return isRailzService(service) ? service : undefined;
}
